
import { EOnboardingActions, OnboardingActions } from "@edp-store/actions/onboarding.actions";
import { initialOnboardingState, IOnboardingState } from "@edp-store/state/onboarding.state";

export function OnboardingReducers(
    state = initialOnboardingState,
    action: OnboardingActions
): IOnboardingState {
    switch (action.type) {
        case EOnboardingActions.SetOnboarding: {
            return {
                ...state,
                onboarding: action.payload,
            };
        }
        case EOnboardingActions.SetOnboardingWhatsNew: {
            return {
                ...state,
                onboardingWhatsNew: action.payload,
            };
        }
        case EOnboardingActions.WhatsNewRequestsAPIError: {
            return {
                ...state,
                whatsNewlastAPIError: action.error,
            };
        }
        default: {
            return state;
        }
    }
}
